module.exports = __webpack_public_path__ + "img/car_shina2_38.19801811.jpg";